module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "district_district"
  }, [_c('div', {
    staticClass: "district_district1 display_column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "district_district_bottom dispaly_flex11"
  }, [_c('div', {
    staticClass: "node_warning media_w_w14"
  }, _vm._l((_vm.warninfo), function(item, index) {
    return _c('div', {
      staticClass: "node_warning_content"
    }, [_vm._v("\n          " + _vm._s(index + 1) + ".\n          "), _c('span', [_vm._v(_vm._s(item.PRJNAME) + "项目【")]), _vm._v(" "), (item.type == 1) ? _c('span', {
      staticStyle: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.DATEDIFF))]) : _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(item.DATEDIFF))]), _vm._v(" "), (item.type == 1) ? _c('span', [_vm._v("】天后将逾期")]) : _c('span', [_vm._v("】天超期")])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "district_district_top dispaly_flex00 media_w_w18 display_row_ac"
  }, [_c('div', {
    staticClass: "district_district_top_1"
  }), _vm._v(" "), _c('span', [_vm._v("项目预警")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1e0c96bb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/theme/left/node_warning/node_warning.vue
// module id = 1068
// module chunks = 1